exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header .cart-dropdown .cart-dropdown-icon .cart-info{position:absolute;width:auto;min-width:16px;height:16px;text-align:center;top:-4px;left:auto;margin-top:0;right:-4px;padding:1px;display:block;line-height:1em;background:#bb141a;background:var(--secondary);border-radius:8px}#header .cart-dropdown .cart-dropdown-icon .cart-qty i{font-size:14px;color:#fff}.cart-actions.save-data{text-align:center}#header .cart-dropdown .cart-dropdownmenu .cart-actions .save-later{font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./ixcms/themes/src/vue-src/top-level/cart-dropdown.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./ixcms/themes/src/vue-src/top-level/cart-dropdown.vue
// module chunks = 24